import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import {
  serializeMedicalTreatmentAppointmentConnectionPayload,
  serializeMedicalTreatmentAppointmentPayload,
} from "@/lib/data/requests/matters/medical-treatment-payloads";
import type {
  APIResponse,
  MedicalTreatmentAppointment,
  MedicalTreatmentAppointmentConnection,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentAppointmentV3 = (
  data: Pick<MedicalTreatmentAppointment, "matterId"> &
    Partial<Omit<MedicalTreatmentAppointment, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MedicalTreatmentAppointment>>(
      "matters/v4/medical-treatments/appointments",
      {
        ...serializeMedicalTreatmentAppointmentPayload(data),
        connections: data.connections ?? [],
      },
    )
    .then((res) => res.data);
};

export const updateMedicalTreatmentAppointmentV1 = (
  data: Pick<MedicalTreatmentAppointment, "id" | "dateModified"> &
    Partial<MedicalTreatmentAppointment>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MedicalTreatmentAppointment>
    >("matters/v3/medical-treatments/appointments", serializeMedicalTreatmentAppointmentPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentAppointmentV1 = (
  data: Pick<MedicalTreatmentAppointment, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentAppointment>
    >(`${baseFastApiMatterRoute}/medical-treatments/appointments/${id}`)
    .then((res) => res.data);
};

export const createMedicalTreatmentAppointmentConnectionV1 = (
  data: Pick<
    MedicalTreatmentAppointmentConnection,
    "matterId" | "medicalTreatmentAppointmentId"
  > & {
    medicalTreatmentBillId?: string;
    medicalTreatmentPlanId?: string;
    medicalTreatmentRecordId?: string;
  },
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MedicalTreatmentAppointmentConnection>
    >(`${baseFastApiMedicalTreatmentRoute}/appointments/connections`, serializeMedicalTreatmentAppointmentConnectionPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentAppointmentConnectionV1 = (
  data: Pick<MedicalTreatmentAppointmentConnection, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentAppointmentConnection>
    >(`${baseFastApiMatterRoute}/medical-treatments/appointments/connections/${id}`)
    .then((res) => res.data);
};
